import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../../theme';
import { Icon } from '../../Icon';

export const StyledIcon = styled(Icon)`
    ${({ theme }: { theme: Theme }) => `
        margin-left: ${theme.tggSpacing(rem(0.8), 1.5)};
	`}
`;
